// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-steps-label[data-v-0025bd5c]{width:11rem}@media(max-width:757px){.wf-steps-label[data-v-0025bd5c]{width:8rem}}", ""]);
// Exports
module.exports = exports;
